import React from "react";
import { useUser } from "../../context/UserContext/UserProvider";
import Logo from "../../assets/imgs/inyc.svg";

const pillClass =
  "inline-flex h-[25px] w-[6.8rem] shrink-0 items-center justify-center rounded-kit-full border px-kit-8 py-kit-2 text-center text-kit-2xs font-['Primary-Medium']";

const VenueCard = ({
  size = 1,
  venue,
  className,
  onUnselect,
  hideOwnershipStatus = false,
  scale = 1,
}) => {
  const { user } = useUser();
  const isOwned = venue?.me || venue?.account_id === user?._id;
  const isClaimed = Boolean(venue?.account_id) && !isOwned;
  const ownershipLabel = isOwned
    ? "owned by you"
    : isClaimed
      ? "claimed by another user"
      : "unclaimed";

  return (
    <div
      className={`venue-card-shell relative mx-auto mb-kit-24 w-[28rem] max-w-full overflow-visible rounded-kit-md border border-[var(--inyc-input-border-color)] bg-[var(--inyc-primary-light)] px-kit-16 pb-kit-16 pt-kit-20 text-left ${className || ""}`}
      style={{
        transform: `scale(${scale})`,
        transformOrigin: "top left",
      }}
    >
      <div className="flex min-w-0 items-center gap-kit-8">
        <div className="min-w-0 overflow-hidden text-ellipsis whitespace-nowrap font-['Primary-Medium'] text-kit-md text-[var(--inyc-primary-text-color)]">
          {venue?.name}
        </div>
        {venue?.venueType && (
          <div className="flex shrink-0 translate-y-[1px] items-center gap-kit-4 text-nowrap rounded-kit-xs bg-[var(--inyc-primary-light)] px-kit-8 py-kit-4 text-kit-2xs font-['Primary-Medium'] text-[var(--inyc-secondary-medium)]">
            {venue.venueType.toLowerCase()}
          </div>
        )}
      </div>

      {venue?.address && (
        <div className="mt-kit-6 min-w-0 overflow-hidden text-ellipsis whitespace-nowrap text-kit-xs font-['Primary-Regular'] text-[var(--inyc-primary-text-color)] opacity-70">
          {venue.address}
        </div>
      )}

      <div className="venue-card-actions-row mt-kit-10 flex w-full items-center justify-between">
        {onUnselect && (
          <button
            type="button"
            className={`${pillClass} venue-card-inverse-pill venue-card-unselect-pill cursor-pointer border-danger bg-white text-danger`}
            onClick={onUnselect}
          >
            unselect
          </button>
        )}
        {!hideOwnershipStatus && (
          <div className="venue-card-ownership-wrap">
            <div
              className={`${pillClass} venue-card-inverse-pill border-[var(--inyc-outline-color)] text-[var(--inyc-primary-text-color)]`}
            >
              {ownershipLabel}
            </div>
          </div>
        )}
        <div className="venue-card-verified-pill flex h-[25px] w-[6.8rem] shrink-0 items-center justify-center gap-kit-4 rounded-kit-full border border-black bg-[var(--inyc-secondary)] px-kit-8 py-kit-2 text-kit-2xs font-['Primary-Medium'] text-[var(--inyc-secondary-text-color)]">
          <img
            src={Logo}
            alt="verified"
            className="h-[1rem] w-[1.4rem] object-contain invert-[var(--inyc-invert-white)]"
          />
          verified
        </div>
      </div>
    </div>
  );
};

export default VenueCard;
